/**
 * Tiny cross-context registry so the 1:1 CallContext and the GroupCallContext
 * can refuse to start while the other has an active call (you can only be in
 * one call at a time). Module-level booleans — no React, no store.
 */
type CallSource = 'oneToOne' | 'group';

let oneToOneActive = false;
let groupActive = false;

export function setCallActive(source: CallSource, active: boolean): void {
  if (source === 'oneToOne') oneToOneActive = active;
  else groupActive = active;
}

/** True if the OTHER kind of call is currently active. */
export function isOtherCallActive(self: CallSource): boolean {
  return self === 'oneToOne' ? groupActive : oneToOneActive;
}
